import { render, staticRenderFns } from "./OpenProductTab.vue?vue&type=template&id=69cbb500&"
import script from "./OpenProductTab.vue?vue&type=script&lang=ts&"
export * from "./OpenProductTab.vue?vue&type=script&lang=ts&"
import style0 from "./OpenProductTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports